// frontend/user/src/components/modals/rename-dialog.tsx
// frame: FoNDD @ ui/dogdisk-user.pen 弹框-重命名(bottom sheet)。
// 2026-06-07 由 @dogdisk/shared Modal 改版为设计稿底部弹层:
// HandleBar + 标题(Bricolage 22/700) + 输入框(2px #19caad 描边) + 确认/取消竖排。
import { useEffect, useState } from 'react'

export type RenameDialogProps = {
  open: boolean
  initialName: string
  busy: boolean
  error: string | null
  onSubmit: (newName: string) => void
  onClose: () => void
}

export function RenameDialog({ open, initialName, busy, error, onSubmit, onClose }: RenameDialogProps) {
  const [name, setName] = useState(initialName)
  useEffect(() => {
    if (open) setName(initialName)
  }, [open, initialName])

  if (!open) return null

  const trimmed = name.trim()
  const invalid = !trimmed || trimmed === initialName || trimmed.length > 255

  return (
    <div
      data-frame-id="FoNDD"
      data-testid="FoNDD"
      role="dialog"
      aria-modal="true"
      aria-label="重命名"
      className="fixed inset-0 z-50 flex items-end bg-black/50"
      onClick={onClose}
    >
      <div
        className="mx-auto w-full max-w-[402px] rounded-t-3xl border border-[#E0E0E0] bg-white pt-2"
        style={{ paddingBottom: 'max(34px, env(safe-area-inset-bottom))' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex h-6 items-center justify-center">
          <span className="h-1 w-10 rounded-full bg-[#E5E7EB]" />
        </div>
        <div className="px-6 py-4">
          <h3 className="text-[22px] font-bold text-[#1A1A1A]" style={{ fontFamily: 'Bricolage Grotesque, ui-sans-serif, system-ui' }}>
            重命名
          </h3>
        </div>
        <div className="px-6">
          <input
            autoFocus
            data-testid="FoNDD-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !invalid && !busy) onSubmit(trimmed)
            }}
            maxLength={255}
            className="h-12 w-full rounded-xl border-2 border-[#19caad] px-4 text-[17px] text-[#1A1A1A] outline-none"
          />
          {error && <p className="mt-2 text-[12px] text-[#FF6B6B]">{error}</p>}
        </div>
        <div className="flex flex-col gap-3 px-6 py-4">
          <button
            type="button"
            data-testid="FoNDD-confirm"
            disabled={invalid || busy}
            onClick={() => onSubmit(trimmed)}
            className="h-12 rounded-xl bg-[#19caad] text-[18px] font-semibold text-white disabled:opacity-50"
          >
            {busy ? '保存中…' : '确认'}
          </button>
          <button
            type="button"
            data-testid="FoNDD-cancel"
            onClick={onClose}
            className="h-12 rounded-xl bg-[#F6F7F8] text-[18px] font-semibold text-[#1A1A1A]"
          >
            取消
          </button>
        </div>
      </div>
    </div>
  )
}
